(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '../../svg'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../../svg'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.svg);
    global.BackArrowButton = mod.exports;
  }
})(this, function (exports, _react, _svg) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var BackArrowButton = function BackArrowButton(_ref) {
    var url = _ref.url;
    return _react2.default.createElement(
      'a',
      { href: url, style: { padding: '1rem', marginLeft: '.5rem' } },
      _react2.default.createElement(_svg.BackArrow, null)
    );
  };

  exports.default = BackArrowButton;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/layout/BackArrowButton.js
// module id = 2282
// module chunks = 1